import React from 'react';
import Sticky from 'react-stickynode';
import { Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { IoMdArrowBack } from 'react-icons/io';
import { MdDomain, MdLocationOn, MdPublic, MdMap } from 'react-icons/md';
import LoadingOverlay from '../../common/LoadingOverlay';
import PhoneScreen from '../../../assets/images/iphone.png';
import classes from './PartnerMobilePreview.module.css';

function PartnerMobilePreview(props) {
    const { partner, logo, mobileSettings, loading } = props;
    const { t } = useTranslation();

    return (
        <Sticky enabled>
            <Row>
                <div className={classes.MobilePreviewContainer}>
                    <img className={classes.PhoneScreen} src={PhoneScreen} alt="phone" />
                    <div className={classes.PhoneScreenContent}>
                        {!loading ?
                            <div>
                                <div className={classes.TopContainer} style={{ background: mobileSettings ? mobileSettings.primaryColor : null }}>
                                    <div className={classes.ArrowContainer}>
                                        <IoMdArrowBack color="#ffff" />
                                    </div>
                                    <div className={classes.LogoContainer}>
                                        {logo ?
                                            <span>
                                                <img className={classes.Logo} src={logo.preview} alt="logo" />
                                            </span>
                                        : null}
                                        {!logo ? 
                                            <span>
                                                <MdDomain size={90} />
                                            </span>
                                        : null}
                                    </div>
                                    <div className={classes.PartnerContainer}>
                                        <span style={{ color: mobileSettings ? mobileSettings.tertiaryFontColor : null }}>
                                            {(partner.displayName && partner.displayName.length > 0) ? partner.displayName : partner.name}
                                        </span>
                                    </div>
                                </div>
                                <div className={classes.IconContainer}>
                                    {(partner.event && partner.event.department) ?
                                        <div>
                                            <span className={classes.Icon}>
                                            <MdLocationOn size={24} color={mobileSettings ? mobileSettings.primaryColor : '#048EBD'} />
                                            </span>
                                            <span className={classes.IconEllipsis} style={{ color: mobileSettings ? mobileSettings.secondaryFontColor : null }}>
                                                {partner.event && (partner.event.department || t('general.department'))}
                                            </span>
                                            <hr className={classes.IconHr} />
                                        </div>
                                    :  null}
                                    {(partner && partner.homepage) ?
                                        <div>
                                            <span className={classes.Icon}>
                                            <MdPublic size={24} color={mobileSettings ? mobileSettings.primaryColor : '#048EBD'} />
                                            </span>
                                            <span className={classes.IconEllipsis} style={{ color: mobileSettings ? mobileSettings.secondaryFontColor : null }}>
                                                {partner.homepage || t('general.homepage')}
                                            </span>
                                            <hr className={classes.IconHr} />
                                        </div>
                                    : null}
                                    {(partner && partner.streetAddress) ?
                                        <div>
                                            <span className={classes.Icon}>
                                            <MdMap size={24} color={mobileSettings ? mobileSettings.primaryColor : '#048EBD'} />
                                            </span>
                                            <span className={classes.IconEllipsis} style={{ color: mobileSettings ? mobileSettings.secondaryFontColor : null }}>
                                                {partner.streetAddress || t('general.street_address')},&nbsp;
                                                {partner.postalCode || t('general.postal_code')}&nbsp;
                                                {partner.city || t('general.city')}
                                            </span>
                                            <hr className={classes.IconHr} />
                                        </div>
                                    : null}
                                </div>
                                {(partner && partner.event && partner.event.description) ?
                                    <div className={classes.PartnerDescription} style={{ paddingLeft: '15px', fontSize: '10px' }}>
                                        <div dangerouslySetInnerHTML={{ __html: `
                                            <style>
                                                img { max-width: 100%; height: auto; }
                                                p { word-break: break-word }
                                            </style>
                                            ${partner.event.description}
                                        `}} />
                                    </div>
                                : null}
                            </div>
                        : <LoadingOverlay />}
                    </div>
                </div>
            </Row>
        </Sticky>
    );
}

export default PartnerMobilePreview;
